module.exports = __webpack_public_path__ + "img/running_man.5ee5e4cd.svg";